module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_mes_mmt_febrero_2026.78c99cb9.jpg";